module.exports = __webpack_public_path__ + "img/6.0e7a6f0c.png";